import React, {useState, useEffect} from "react"
import styled from "styled-components"
import Banking from "./Banking/Banking";
const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
    Btn:styled.div`
        width:90px;
        height:45px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
}

interface PropsType{
    Points : number;
    setPoints : any;
}
const LivePoint=(props:PropsType)=>{
    const setPoints = props.setPoints
    const Points = props.Points
    
    const [NextPage, setNextPage] = useState<boolean>(false)
    const LivePnt = [
        "1년 미만",
        "1년 이상",
        "2년 이상",
        "3년 이상"
    ]
    if(NextPage === false){
        return(
            <Styled.Wrap>
                <Styled.LittleTitleFont>청약을 도전하시려는 지역에서<br/>거주한 기간이 어떻게 되시나요?</Styled.LittleTitleFont>
                <Styled.BtnWrap>
                    {LivePnt.map((v:string, idx:number)=>{
                        return(
                          <Styled.Btn onClick={()=>{
                              setPoints(Points + idx);
                              setNextPage(true);
                          }} >
                              <Styled.Fonts>{v}</Styled.Fonts>
                          </Styled.Btn>
                      )
                    })}
                </Styled.BtnWrap>
            </Styled.Wrap>
          )
    }else{
        // 결과페이지
        // 청약통장 납입 횟수 빼먹음 ㅋㅋ
        return(
            <Banking 
                setPoints={setPoints}
                Points={Points}
            />
        )
    }
    
}

export default LivePoint